import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Modal, Spinner } from 'react-bootstrap';
import { FaFileExcel, FaArrowLeft, FaSearch, FaBuilding, FaUtensils, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { proyectoClienteApi } from '../../services/api/proyectoClienteApi';
import { proyectoApi } from '../../services/api/proyectoApi';
import { reporteApi } from '../../services/api/reporteApi';

const ReporteConsolidadoConsumosPorFechas = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fecha_servicio_desde: '',
    fecha_servicio_hasta: '',
    cliente_id: '',
    comedor_id: ''
  });

  const [clientes, setClientes] = useState([]);
  const [comedores, setComedores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));

  useEffect(() => {
    if (selectedProject?.id) {
      loadClientes();
      loadComedores();
    }
  }, []);

  const loadClientes = async () => {
    if (!selectedProject?.id) {
      setError('No hay proyecto seleccionado');
      return;
    }

    try {
      const response = await proyectoClienteApi.getClientesByProyecto(selectedProject.id);
      setClientes(response.data || []);
    } catch (error) {
      console.error('Error loading clients:', error);
      setError('Error al cargar los clientes del proyecto');
    }
  };

  const loadComedores = async () => {
    if (!selectedProject?.id) {
      setError('No hay proyecto seleccionado');
      return;
    }

    try {
      const response = await proyectoApi.getComedores(selectedProject.id);
      setComedores(response.data || []);
    } catch (error) {
      console.error('Error loading comedores:', error);
      setError('Error al cargar los comedores del proyecto');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGenerateReport = async (e) => {
    e.preventDefault();
    
    if (!formData.fecha_servicio_desde || !formData.fecha_servicio_hasta || !formData.cliente_id || !formData.comedor_id) {
      setError('Por favor complete todos los campos obligatorios');
      return;
    }

    if (new Date(formData.fecha_servicio_desde) > new Date(formData.fecha_servicio_hasta)) {
      setError('La fecha desde no puede ser mayor que la fecha hasta');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await reporteApi.reporteConsolidadoConsumosPorFechasExcel(formData);
    } catch (error) {
      console.error('Error generating report:', error);
      setError('Error al generar el reporte: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/reportes');
  };

  return (
    <>
      <Modal
        show={loading}
        backdrop="static"
        keyboard={false}
        centered
        aria-labelledby="reporte-consolidado-fechas-loading-title"
      >
        <Modal.Body className="text-center py-5 px-4">
          <div className="d-flex justify-content-center mb-3">
            <Spinner
              animation="border"
              role="status"
              variant="primary"
              style={{ width: '3.5rem', height: '3.5rem' }}
            />
          </div>
          <FaFileExcel className="text-success mb-3" style={{ fontSize: '2rem' }} aria-hidden />
          <h5 id="reporte-consolidado-fechas-loading-title" className="mb-2">
            Generando el reporte Excel
          </h5>
          <p className="text-muted mb-0 small">
            Por favor espere. Con muchos datos o un rango amplio de fechas el proceso puede tardar varios minutos.
          </p>
        </Modal.Body>
      </Modal>

      <style>
        {`
          .dh-reports-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          .dh-main-header {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(0, 198, 255, 0.2);
          }
          
          .dh-main-title {
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0;
          }
          
          .dh-main-subtitle {
            font-size: 1rem;
            opacity: 0.9;
            margin: 0.5rem 0 0 0;
          }
          
          .dh-form-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            overflow: hidden;
          }
          
          .dh-form-header {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            color: white;
            padding: 1.5rem;
            margin: 0;
            font-size: 1.25rem;
            font-weight: 600;
          }
          
          .dh-form-body {
            padding: 2rem;
          }
          
          .form-label {
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.5rem;
          }
          
          .form-control, .form-select {
            border: 2px solid #e2e8f0;
            border-radius: 12px;
            padding: 12px 16px;
            font-size: 14px;
            transition: all 0.3s ease;
            background: white;
          }
          
          .form-control:focus, .form-select:focus {
            border-color: #00c6ff;
            box-shadow: 0 0 0 0.2rem rgba(0, 198, 255, 0.25);
            background: white;
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 24px;
            font-weight: 600;
            font-size: 16px;
            box-shadow: 0 4px 14px rgba(0, 114, 255, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #0072ff 0%, #0056cc 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 114, 255, 0.4);
            color: white;
          }
          
          .btn-dh-primary:disabled {
            background: #6c757d;
            transform: none;
            box-shadow: none;
          }
          
          .btn-dh-back {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-back:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .dh-info-card {
            background: rgba(255, 255, 255, 0.95);
            border: none;
            border-radius: 15px;
            padding: 1.5rem;
            margin-bottom: 2rem;
            box-shadow: 0 5px 15px rgba(0,0,0,0.08);
          }
          
          .dh-info-title {
            color: #2d3748;
            font-weight: 700;
            margin-bottom: 1rem;
            font-size: 1.1rem;
          }
          
          .dh-info-item {
            display: flex;
            align-items: center;
            margin-bottom: 0.75rem;
            color: #4a5568;
          }
          
          .dh-info-icon {
            margin-right: 0.75rem;
            color: #00c6ff;
          }
          
          .alert-danger {
            border: none;
            border-radius: 12px;
            background: linear-gradient(135deg, #fee 0%, #fdd 100%);
            border-left: 4px solid #dc3545;
            color: #721c24;
          }
          
          .required {
            color: #dc3545;
          }
          
          .loading-spinner {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 2px solid #ffffff;
            border-radius: 50%;
            border-top-color: transparent;
            animation: spin 1s ease-in-out infinite;
            margin-right: 0.5rem;
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      <div className="dh-reports-bg">
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaFileExcel className="me-3" />
                  Consolidado de Consumos por Fechas
                </h1>
                <p className="dh-main-subtitle">
                  Reporte consolidado de consumos totales por fecha, servicio y comedor
                </p>
              </div>
              <Button 
                className="btn-dh-back d-flex align-items-center"
                onClick={handleBack}
              >
                <FaArrowLeft className="me-2" />
                Volver a Reportes
              </Button>
            </div>
          </Container>
        </div>

        <Container className="py-4">
          {/* Información del Proyecto */}
          <div className="dh-info-card">
            <h5 className="dh-info-title">📋 Información del Reporte</h5>
            <Row>
              <Col md={6}>
                <div className="dh-info-item">
                  <FaBuilding className="dh-info-icon" />
                  <span><strong>Proyecto:</strong> {selectedProject?.nombre || 'No seleccionado'}</span>
                </div>
              </Col>
              <Col md={6}>
                <div className="dh-info-item">
                  <FaFileExcel className="dh-info-icon" />
                  <span><strong>Formato:</strong> Excel (.xlsx)</span>
                </div>
              </Col>
              <Col md={6}>
                <div className="dh-info-item">
                  <FaUtensils className="dh-info-icon" />
                  <span><strong>Agrupación:</strong> Por fechas y servicios</span>
                </div>
              </Col>
              <Col md={6}>
                <div className="dh-info-item">
                  <FaCalendarAlt className="dh-info-icon" />
                  <span><strong>Período:</strong> Rango de fechas seleccionado</span>
                </div>
              </Col>
            </Row>
          </div>

          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          {/* Formulario */}
          <Card className="dh-form-card">
            <div className="dh-form-header">
              <FaSearch className="me-2" />
              Parámetros del Reporte
            </div>
            <div className="dh-form-body">
              <Form onSubmit={handleGenerateReport}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Fecha Desde <span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="fecha_servicio_desde"
                        value={formData.fecha_servicio_desde}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Fecha Hasta <span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="fecha_servicio_hasta"
                        value={formData.fecha_servicio_hasta}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Cliente <span className="required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="cliente_id"
                        value={formData.cliente_id}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Seleccione un cliente...</option>
                        {clientes.map((cliente) => (
                          <option key={cliente.id} value={cliente.id}>
                            {cliente.nombre}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Comedor <span className="required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="comedor_id"
                        value={formData.comedor_id}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Seleccione un comedor...</option>
                        {comedores.map((comedor) => (
                          <option key={comedor.id} value={comedor.id}>
                            {comedor.nombre}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center mt-4">
                  <Button
                    type="submit"
                    className="btn-dh-primary d-flex align-items-center"
                    disabled={loading}
                    size="lg"
                  >
                    {loading && <div className="loading-spinner"></div>}
                    <FaFileExcel className="me-2" />
                    {loading ? 'Generando Reporte...' : 'Descargar Reporte Excel'}
                  </Button>
                </div>
              </Form>
            </div>
          </Card>

          {/* Información adicional */}
          <Row className="mt-4">
            <Col>
              <div className="dh-info-card">
                <h6 className="dh-info-title">ℹ️ Acerca de este Reporte</h6>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong>📊 Estructura del Reporte</strong>
                      <p className="mb-0 small text-muted">
                        Las fechas se muestran como filas y los servicios como columnas organizadas por comedor
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong>📈 Totales Incluidos</strong>
                      <p className="mb-0 small text-muted">
                        Se incluyen totales por servicio y totales generales al final del reporte
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong>🎯 Datos Mostrados</strong>
                      <p className="mb-0 small text-muted">
                        Total de consumos para cada combinación de fecha, servicio y comedor
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ReporteConsolidadoConsumosPorFechas;